import React, { Component } from "react";
import { Input, Space } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

export default class AppUploadPassword extends Component {
    constructor(props) {
        super(props);
    }

    get attrs() {
        return Object.except(this.props, [
            'onPasswordChange',
            'haspassword'
        ]);
    }

    iconRender(visible) {
        return visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
    }

    render() {
        let { iconRender, props,attrs } = this;
        let { outerclass, passwordclass, fileClass, name, editaccess, password, haspassword = true,from="root" } = props;
        return (
            <>
                <div className={outerclass || "col d-flex flex-wrap"}>
                    <div className={`d-flex align-items-center grow ${fileClass || ""}`}>
                        {
                            from=="root" ? <AppInput
                                className="w-100"
                                type="file"
                                label={this.props.label}
                                name={name}
                                editaccess={editaccess}
                                {...attrs}
                            ></AppInput>
                            :
                            <AppUpload
                                className="w-100"
                                type="file"
                                label={this.props.label}
                                name={name}
                                editaccess={editaccess}
                                {...attrs}
                            ></AppUpload>
                        }
                    </div>
                    {
                        haspassword && <div className={`d-flex align-items-center ${from!='root'&&this.props.label?'':'mt-4'} ${passwordclass||''}`}>
                            <Space direction="vertical">
                                <Input.Password
                                    name={`${name}_filepassword`}
                                    autoComplete={"new-password"}
                                    className="antd_custome_password_field"
                                    placeholder="Enter the file password"
                                    defaultValue={password}
                                    iconRender={iconRender}
                                    onChange={(e) => props.onPasswordChange && props.onPasswordChange(e)}
                                />
                            </Space>
                        </div>
                    }

                </div>
            </>
        );
    }
}